import { InvoiceCategoriesEnum, SoStatusEnum } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";
import { InvoiceItemsInfo } from "./plant-invoice-items.dto";

export class PlantInvoiceDto{
    @ApiProperty()
    invoiceId: number;
    @ApiProperty()
    saleOrderId: number;
    @ApiProperty()
    invoiceNumber: string;
    @ApiProperty()
    invoiceDate: string;
    @ApiProperty()
    portOfLoading:number;
    @ApiProperty()
    portOfDischarge:number;
    @ApiProperty()
    exporterId: number;
    @ApiProperty()
    unitId: number;
    @ApiProperty()
    customerId: number;
    @ApiProperty()
    endCustomerId: number;
    @ApiProperty()
    flightNumber: string;
    @ApiProperty()
    exchangeRate: number;
    @ApiProperty()
    liner: number;
    @ApiProperty()
    freightCharges: number;
    @ApiProperty()
    totalAmount: number;
    @ApiProperty()
    total_INR_amount: number;
    @ApiProperty()
    isActive: boolean;
    @ApiProperty()
    createdUser: string | null;
    @ApiProperty()
    updatedUser: string | null;
    @ApiProperty()
    invoiceItemsInfo: InvoiceItemsInfo[];
    @ApiProperty()
    isTaxApplicable?: string;
    @ApiProperty()
    saleCommission?: number;
    @ApiProperty()
    insurance?: number;
    @ApiProperty()
    finNumber?: string;
    @ApiProperty()
    paymentTerms?: number;
    @ApiProperty()
    finalDestination?: number;
    @ApiProperty()
    notifyPartyOne?: number;
    @ApiProperty()
    notifyPartyTwo?: number;
    @ApiProperty()
    notifyPartyThree?: number;
    @ApiProperty()
    orderDate?: string;
    @ApiProperty()
    notifyPartyFour?: number;
    @ApiProperty()
    placeOfReceipt?: string;
    @ApiProperty()
    etaDate?: string;
    @ApiProperty()
    bankReachedDate?: string;
    @ApiProperty()
    invoiceCategory?: InvoiceCategoriesEnum;
    @ApiProperty()
    epcgLicenseNumber?:string;
    @ApiProperty()
    epcgLicenseDate?:string;
    @ApiProperty()
    epcgFobValue?:number;
    @ApiProperty()
    exportObligation?:number;
    @ApiProperty()
    qCertificateNo?:string;
    @ApiProperty()
    grossWeight?:number;
    @ApiProperty()
    frozenWeight?:number;
    @ApiProperty()
    refNumber?:number;
    @ApiProperty()
    remarks?:string;
    @ApiProperty()
    dcNo?:string;
    @ApiProperty()
    dcDate?:string
    @ApiProperty()
    marksAndNo?:string;
    @ApiProperty()
    packageType?:string;
        @ApiProperty()
    netWeight?:number;
    @ApiProperty()
    eWayBillNo?: string;
    @ApiProperty()
    destAddress?: string;
}
